// extracted by mini-css-extract-plugin
module.exports =  {"list":"ActivityChooser-BaJi__list","active":"ActivityChooser-nsRU__active"};